import * as actionTypes from '../ActionTypes';
import { updateObject } from '../../Shared/Utils';

const initialState = {
    entries: [],
    error: null,
    loading: false,
};

const entriesListStart = (state) => {
    return updateObject(state, { error: null, loading: true });
};

const entriesListSuccess = (state, action) => {
    return updateObject(state, {
        entries: action.entries,
        error: null,
        loading: false,
    });
};

const entriesListFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false,
    });
};



const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ENTRIES_START:
            return entriesListStart(state, action);
        case actionTypes.ENTRIES_SUCCESS:
            return entriesListSuccess(state, action);
        case actionTypes.ENTRIES_FAIL:
            return entriesListFail(state, action);


        default:
            return state;
    }
};

export default reducer;
